/**
 * お問い合わせページに表示する期間限定お知らせの設定
 */
import isWithinRange from "date-fns/is_within_range";

export interface ContactNotice {
  title: string;
  message: string;
  startAt: Date;
  endAt: Date;
}

/**
 * 年末年始お知らせ設定
 */
export const yearEndNotice: ContactNotice = {
  title: "年末年始期間中のお問い合わせ対応につきまして",
  message:
    "2025年12月27日(土)〜2026年1月4日(日)の間、お問い合わせへの回答にお時間をいただく場合がございます（1月5日以降、順次回答）。",
  startAt: new Date("2025-12-10T00:00:00+09:00"),
  endAt: new Date("2026-01-07T23:59:59+09:00"),
};

/**
 * 現在表示すべきお知らせを取得する
 */
export const getActiveContactNotice = (): ContactNotice | null => {
  const now = new Date();

  if (isWithinRange(now, yearEndNotice.startAt, yearEndNotice.endAt)) {
    return yearEndNotice;
  }

  return null;
};
